import React, { Fragment, Component } from "react";

import Slider from "react-slick";

import conference from "../../../assets/utils/images/top-img.png";
import live_call from "../../../assets/utils/images/live-calls.png";
import video_api from "../../../assets/utils/images/video-api.png";
import video_kiosk from "../../../assets/utils/images/video-kiosk.png";

import { withRouter } from "react-router";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { auth, signInWithGoogle } from "../../../Auth/Firebase";
import { isAuthenticated, setAuthenticated, setToken } from "../../../States/Token";
import { config } from "../../../config";
import { get_landing_page } from "../../../Helpers/Router";
import { postCall } from "../../../Helpers/Api";
import { bottomAlert } from "../../../Components/Notifications/ToastAlerts";
import { getCookie, setCookie } from "../../../Helpers/Cookie";

class Otp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      message: "",
      disable_input: false,
      userEamil: "",
    };

    this.signInWithOtp = this.signInWithOtp.bind(this);
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(document.location.search);
    const email = searchParams.get("email");
    this.setState({ userEamil: email });
    if (!email) {
      // this.props.history.push(get_landing_page());
      this.props.history.push("/auth/login");
      return
    }
    if (isAuthenticated()) {
      this.props.history.push("/workspace/admin");
      return
    }
    postCall({
      url: config.url.SEND_OTP_ON_EMAIL,
      data: { email: email },
      onSuccess: (response) => {
        bottomAlert("Successfullt sent OTP.", "success");
        this.setState({ show_overlay: false });
        //
      },
      onFailure: (error) => {
        bottomAlert(
          "Unable to complete your request. " +
            ((error.response && error.response.data.detail) ||
              error.toString()),
          "warning"
        );
      },
    });
  }

  signInWithOtp = (otp) => {
    this.setState({ message: "" });
    const searchParams = new URLSearchParams(document.location.search);
    const email = searchParams.get("email");
    if (!email.trim()) {
      this.setState({ message: "Email cannot be empty." });
      return;
    }
    if (!otp.trim()) {
      this.setState({ message: "OTP cannot be empty." });
      return;
    }
    postCall({
      url: config.url.LOGIN_WITH_EMAIL_OTP,
      data: { email: email, otp: this.state.otp },
      onSuccess: (response) => {
        bottomAlert("OTP verified.", "success");
        this.setState({ show_overlay: false });
        setCookie("saleassist_auth_token", response.data);
        setToken(getCookie("saleassist_auth_token"));
        setAuthenticated(true);
        window.location.href = "/workspace/admin";
      },
      onFailure: (error) => {
        bottomAlert(
          "Unable to complete your request. " +
            ((error.response && error.response.data.detail) ||
              error.toString()),
          "warning"
        );
      },
    });
    // auth
    //   .signInWithEmailAndPassword(otp)
    //   .then((response) => {
    //     // this.props.history.push(get_landing_page());
    //     this.setState({ disable_input: false });
    //   })
    //   .catch((error) => {
    //     this.setState({ message: error.message });
    //     this.setState({ disable_input: false });
    //   });
  };

  handleEnterPress = (event, callback) => {
    if (event.key === "Enter") {
      callback();
    }
  };

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };

    const searchParams = new URLSearchParams(document.location.search);
    const email = searchParams.get("email");
    return (
      <Fragment>
        <div className="h-100">
          <Row className="h-100 no-gutters">
            {/* <Col lg="4" className="d-none d-lg-block">
              <div className="slider-dark">
                <Slider {...settings}>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + conference + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>Secure video conferencing</h3>
                      <p>
                        Secure and safe environment customized with your
                        company's brand logo and theme.
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + video_api + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>API driven. Build. Experience.</h3>
                      <p>
                        SaleAssist can be integrated into any of your business
                        process, e.g integration with ERP or a Ticketing system.
                        We have Transactional Video call APIs by which you can
                        have on-demand video call generated, programatically !
                        Whether you are an enterprise or a startup, we have
                        solutions for all scale. These are REST APIs and have
                        simple integration.
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + live_call + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>Live Calls</h3>
                      <p>
                        Live Call gets plugged in to your application and
                        enables direct video calling. Let it be website or a
                        custom application, with just inserting few lines of
                        code , Live Call makes your frontend video call enabled.
                        It’s that simple ! Features include multiple agent
                        management, reports & analytics and did we mention your
                        first 100 Video calls are on us!
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + video_kiosk + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>Video Kiosk</h3>
                      <p>
                        In times of social distancing, video kiosk offers
                        immense value to engage & interact with your walk in
                        customers. Have live video conversation with visitors
                        while your customer representatives may be remotely
                        working. Did we mention earlier that all conversations
                        get recorded for quality purposes
                      </p>
                    </div>
                  </div>
                </Slider>
              </div>
            </Col> */}
            <Col
              lg="12"
              md="12"
              className="h-100 d-flex bg-white justify-content-center align-items-center"
            >
              <Col
                lg="9"
                md="10"
                sm="12"
                className="mx-auto app-login-box"
                style={{ textAlign: "center" }}
              >
                {/* <div className="app-block-logo" /> */}
                <div className="app-logo" />
                <h4 className="mb-0">
                  <div>Welcome to SaleAssist,</div>

                  {email ? (
                    <span>
                      OTP has been sent to{" "}
                      <span>
                        <u>{email}</u>
                      </span>
                    </span>
                  ) : (
                    <span>Please sign in to your account.</span>
                  )}
                </h4>

                <Row className="divider" />

                <div>
                  <Form onSubmit={(e) => e.preventDefault()}>
                    <Row form>
                      <div className="mx-auto">
                        <Col md={12}>
                          <FormGroup>
                            <Label for="otp">OTP</Label>
                            <Input
                              type="number"
                              name="otp"
                              id="otp"
                              placeholder="Enter OTP..."
                              onChange={(e) => {
                                this.setState({ otp: e.target.value });
                              }}
                              value={this.state.otp}
                              disabled={this.state.disable_input}
                              onKeyPress={(e) =>
                                this.handleEnterPress(e, () => {
                                  this.signInWithOtp(
                                    //   this.state.email,
                                    this.state.otp
                                  );
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                      </div>
                    </Row>
                    <h6 className="mt-3 text-danger">{this.state.message}</h6>
                    {/* <FormGroup check>
                      <Input type="checkbox" name="check" id="exampleCheck" />
                      <Label for="exampleCheck" check>
                        Keep me logged in
                      </Label>
                    </FormGroup> */}
                    <Row className="divider" />
                    <div
                      className="d-flex align-items-center"
                      style={{ textAlign: "center" }}
                    >
                      <div className="mx-auto">
                        <Button
                          color="primary"
                          size="lg"
                          onClick={(e) => {
                            e.preventDefault();
                            this.signInWithOtp(this.state.otp);
                          }}
                          disabled={this.state.disable_input}
                        >
                          Login to Dashboard
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(Otp);
